import React from "react"
import type { CustomFieldMultiselect } from "@love-irish/types"
import { Badge } from "@love-irish/ui-components"

const MultiselectField = ({ field }: { field: CustomFieldMultiselect }) => {
  const displayValue = Array.isArray(field.value)
    ? field.value.join(", ")
    : field.value

  return (
    <Badge variant="outline">
      <strong className="mr-1">{field.label}:</strong> {displayValue}
    </Badge>
  )
}

export default MultiselectField
